import { KiteButton, KiteIcon } from '@kite/react-kite';
import React, { useState } from 'react';
import './CollapsibleTableRow.scss';
import { SmartLink } from '../SmartLink/SmartLink';
import { CollapsibleTableRowChild } from './CollapsibleTableRowChild';
export interface CollapsibleTableRowInputs {
    mainText: string;
    secondaryText: string;
    url: string;
    id: string;
    rowExpanded: boolean;
    nestedRows?: CollapsibleTableRowChildProps[];
    handleExpansionClick: () => void;
}

export interface CollapsibleTableRowChildProps {
    field_main_text: string;
    field_secondary_text: string;
    field_url: string;
    id: string;
}

export const CollapsibleTableRow = ({
    mainText,
    secondaryText,
    url,
    nestedRows,
    rowExpanded,
    handleExpansionClick,
}: CollapsibleTableRowInputs) => {
    const [nRows, setNRows] = useState(nestedRows);

    const InnerContent = () => (
        <>
            <span>{mainText}</span>
            <span>
                {secondaryText}
                {url && <KiteIcon size="0.75rem" icon="ki-chevron-right" />}
                {nRows?.length > 0 && (
                    <KiteButton
                        variant="borderless"
                        onClick={handleExpansionClick}
                        icon={rowExpanded ? `ki-chevron-up` : `ki-chevron-down`}
                        type="button"
                        aria-expanded={rowExpanded}
                        aria-label={`${
                            rowExpanded ? `Collapse` : `Expand`
                        } ${mainText} row`}
                    />
                )}
            </span>
        </>
    );

    return (
        <li
            className={`paragraph__collapsible_table_row typestack-body-1 ${
                nRows?.length > 0 && `nested-content`
            } ${rowExpanded ? `expanded` : ``} `}
        >
            <div>
                {url && (
                    <SmartLink url={url} newWindow>
                        <InnerContent />
                    </SmartLink>
                )}
                {!url && <InnerContent />}
            </div>

            {nRows?.length > 0 && rowExpanded && (
                <ul aria-hidden={!rowExpanded}>
                    {nRows.map((nrow, index) => (
                        <CollapsibleTableRowChild
                            key={`${nrow}_${index}`}
                            node={nrow}
                            aria-hidden={!rowExpanded}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};
